import {
  Component,
  OnInit,
  ViewChild
} from '@angular/core';
import { ActivatedRoute } from '@angular/router'
import { Observable } from 'rxjs/Observable';
declare var _: any;

import { AgencyLocationService } from '../api/resources/agency-location.service';
import { SurveyService } from '../api/resources/survey.service';
import { Survey } from '../api/resources/survey';
import { SessionService } from '../api/session.service';
import { RespondentService } from '../api/resources/respondents.service';

@Component({
  selector: 'app-survey',
  templateUrl: './survey.component.html',
  styleUrls: ['./survey.component.less'],
  providers: [
    AgencyLocationService,
    SurveyService,
    SessionService,
    RespondentService
  ]
})
export class SurveyComponent implements OnInit {
  @ViewChild('mainStage') stageHost: any;
  location_id: string;
  survey_id: string;
  saved_id: string;
  loading: boolean = true;
  locationName: string;
  survey: Survey;
  activePageIndex: any = 0;
  progress: Array<any> = [];
  responseRecord: Array<any> = [];
  savingRecord: boolean = false;
  lastSaved: any;
  reQueSavingRecord: boolean = false;
  disconnected: boolean = false;
  disconnectedMessage: string;
  submitting: boolean = false;
  submitted: boolean = false;
  submissionError: boolean = false;
  previewScore: Object = {};
  totalErrors: number = 0;

  constructor(private route: ActivatedRoute,
              private locationService: AgencyLocationService,
              private surveyService: SurveyService,
              private session: SessionService,
              private respondent: RespondentService) { }

  ngOnInit() {
    this.location_id = this.route.snapshot.params['location_id'];
    this.survey_id = this.route.snapshot.params['survey_id'];
    this.saved_id = this.route.snapshot.params['saved_progress'];

    if (this.location_id) {
      this.locationService.detail(this.location_id)
        .subscribe(res => {
          this.locationName = res.semantic_name || res.name;
        })
    }

    if (this.saved_id) {
      this.respondent.getSaved(this.saved_id)
        .subscribe(res => {
          const saved_survey = res.survey;
          if (saved_survey.info_page) {
            const info_page = saved_survey.info;
            saved_survey.components = _.concat(info_page, saved_survey.components);
            this.survey = saved_survey;
          } else {
            this.survey = saved_survey;
          }
          this.survey.responses = res.responses;
          this.buildResponseRecord(this.survey);
          this.buildProgressTracker(this.survey);
          this.lastSaved = res.updated_on;
          this.loading = false;
        }, err => console.log(err));
    } else if (this.survey_id) {
      this.surveyService.detail(this.survey_id)
        .subscribe(res => {
          this.survey = res;
          this.buildResponseRecord(res);
          this.buildProgressTracker(res);
          this.loading = false;
        }, err => console.log(err));
    }
  }

  buildResponseRecord(survey: any) {
    // setup array as it will be needed for the surver
    let responses: Array<any> = [];
    let questions: Array<any> = [];

    this.responseRecord = [];

    const buildQuestions = (obj: any) => {
      _.each(obj.components, (item: any) => {
        if (item.type === 'section') {
          buildQuestions(item);
        } else if (item.type === 'question') {
          questions.push(item);
        }
      });
    };

    _.each(survey.components, (page: any) => buildQuestions(page));


    _.each(questions, (q: any) => {
      _.each(q.rows, (r: any) => {
        let value;

        if (q.qType === 'radio' || q.qType === 'checkbox') {
          value = r.value || false;
        } else if (q.qType === 'range' && r.value === 0) {
          value = 0;
        } else {
          value = r.value || null;
        }

        // We find the response because the error exists in the actual response list.
        let response = _.find(this.survey.responses, (o: any) => o.question_id === q.id);

        responses.push({
          question_id: q.id,
          answer_id: r.id,
          value: value,
          error: (response && response.error) || ""
        });
      });
    });

    this.responseRecord = responses;
    this.getTotalErrors(this.survey.responses);
  };

  saveProgress(question?: any) {
    const cycle = () => {
      this.savingRecord = false;
      this.disconnected = false;
      if (this.reQueSavingRecord) {
        this.reQueSavingRecord = false;
        this.saveProgress();
      }
    };

    if (question) {
      // update this.responseRecord
      _.each(question.rows, (row: any) => {
        let record = _.find(this.responseRecord, (record: any) => {
          return record.answer_id === row.id;
        });
        if (question.qType === 'radio' || question.qType === 'checkbox') {
          record.value = row.value || false;
        } else if (question.qType === 'range' && row.value === 0) {
          record.value = 0;
        } else {
          record.value = row.value || null;
        }

        record.error = row.error;
      });
    }

    if (this.savingRecord) {
      // if it's saving, set to run again after
      this.reQueSavingRecord = true;
      return;
    }

    this.savingRecord = true;

    let body: any = {
      agency: this.session.agency_id,
      survey: this.survey._id,
      status: 'incomplete',
      user: this.session._id || undefined,
      location: this.location_id || undefined,
      responses: this.responseRecord
    };

    if (this.saved_id) {
      this.respondent.update(this.saved_id, body)
        .subscribe(res => {
          this.lastSaved = res.updated_on;
          this.getTotalErrors(res.responses);
          cycle();
        }, err => {
          cycle();
          this.setDisconnected();
          console.log('Error', err);
        });
    } else {
      this.surveyService.createSurveyRespondent(this.survey._id, body)
        .subscribe(res => {
          this.saved_id = res._id;
          this.lastSaved = res.updated_on;
          this.getTotalErrors(res.responses);
          cycle();
        }, err => {
          cycle();
          this.setDisconnected();
          console.log('Error', err);
        });
    }
  }

  setDisconnected() {
    this.disconnectedMessage = 'Reconnecting in 10 seconds';
    this.disconnected = true;
    setTimeout(() => {
      this.disconnectedMessage = 'Attempting reconnect';
      this.saveProgress();
    }, 10000);
  }

  buildProgressTracker(survey: any) {
    // count number of questions & answers for each page
    _.each(survey.components, (page: any) => {
      let tracker = {
        questions: 0,
        answered: 0
      };
      let setTracking = (q: any) => {
        let hasValue: boolean = _.some(q.rows, (row: any) => row.value || row.value === 0);
        if (hasValue) tracker.answered += 1;
        tracker.questions += 1;
      };

      _.each(page.components, (item: any) => {
        if (item.type === 'section') {
          _.each(item.components, (q: any) => {
            setTracking(q);
          });
        } else {
          setTracking(item);
        }
      });

      this.progress.push(tracker);
    });
  }

  updateProgress(pageIndex: number, addAnswer: boolean) {
    if (addAnswer) {
      this.progress[pageIndex].answered += 1;
    } else {
      this.progress[pageIndex].answered -= 1;
    }
  }

  getErrorCountByPage(index: number) {
    let count = 0;

    if (index > this.survey.components.length) {
      return count;
    }

    let page = this.survey.components[index];

    _.each(page.components, (item: any) => {
        if (item.type === 'section') {
          _.each(item.components, (q: any) => {
            let response = _.find(this.responseRecord, (o: any) => o.question_id === q.id);
            if (response && response.error) {
              ++count;
            }
          });
        } else {
          let response = _.find(this.responseRecord, (o: any) => o.question_id === item.id);
          if (response && response.error) {
            ++count;
          }
        }
    });

    return count;
  }

  getTotalErrors(responses) {
    let total = 0;

    _.each(responses, (o: any) => {
      if (o.error) total += 1;
    });

    return this.totalErrors = total;
  }

  getTotalProgress(type: string) {
    return _.sumBy(this.progress, (p: any) => {
      return p[type];
    });
  }

  changePage(index: number, direction?: string) {
    if (direction) {
      this.activePageIndex = direction === 'up' ? this.activePageIndex + 1 : this.activePageIndex - 1;
    } else {
      this.activePageIndex = index;
    }

    if (index === -1 && this.survey.show_completion_score)
      this.calculatePreviewScore();

    this.stageHost.nativeElement.scrollTop = 0;
  }

  calculatePreviewScore() {
    this.previewScore = {};

    let body: any = {
      agency: this.session.agency_id,
      survey: this.survey._id,
      status: 'incomplete',
      user: this.session._id || undefined,
      location: this.location_id || undefined,
      responses: this.responseRecord
    };

    this.surveyService.calculateScore(this.survey._id, body)
      .subscribe(res => {
        this.previewScore = {
          score: res.score.score,
          grade: res.score.grade
        };
      }, err => {
        this.previewScore = {
          error: 'Unable to calculate, please check internet connection. Contact support if issue persist.'
        };
        console.log('Preview Score Calculation Err', err);
      });
  }

  submit() {
    this.submitting = true;
    this.submitted = false;
    this.submissionError = false;

    // rebuild the responseRecord to be safe
    this.buildResponseRecord(this.survey);

    let body: any = {
      agency: this.session.agency_id,
      survey: this.survey._id,
      status: 'complete',
      user: this.session._id || undefined,
      location: this.location_id || undefined,
      responses: this.responseRecord
    };

    if (this.saved_id) {
      // Update saved respondent
      this.respondent.update(this.saved_id, body)
        .subscribe(res => {
          this.submitted = true;
        }, err => {
          this.submissionError = true;
          console.log('Error', err);
        });
    } else {
      // Submit new respondent
      this.surveyService.createSurveyRespondent(this.survey._id, body)
        .subscribe(res => {
          this.submitted = true;
        }, err => {
          this.submissionError = true;
          console.log('Error', err);
        });
    }
  }

  cancelSubmit() {
    // if submit fails, user can cancel
    this.submitting = false;
    this.submitted = false;
    this.submissionError = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/survey/survey.component.ts